export default "__VITE_ASSET__c6a7b1df__"